export default {
  white: '#E4E4E4',
  black: '#000000',
  fontSerif: 'cirka, serif',
  fontSans: 'lazzer, sans-serif',
  colorBg: '#000000',
  bolorBgLight: 'rgba(0, 0, 0, 0.2)',
  colorMain: '#E4E4E4',
  colorBgInverted: '#E4E4E4',
  colorMainInverted: '#000000',
  maxWidth: '1360px'
};